/* istanbul ignore file */
export { default } from './NumberSelectNew';
